const utmLastTouch = (Analytics, utmValues) => {
  const campaignKeywords = 'utm_source utm_medium utm_campaign'.split(' ');
  let kw = '';
  const lastParams = {};
  const firstParams = {};
  let index;
  for (index = 0; index < campaignKeywords.length; ++index) {
    kw = utmValues[campaignKeywords[index]];
    if (kw && kw.length) {
      lastParams[`${campaignKeywords[index]} [last touch]`] = kw;
      firstParams[`${campaignKeywords[index]} [first touch]`] = kw;
    }
  }

  Analytics.offersLastTouch(firstParams, lastParams);
};

export default utmLastTouch;
